var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckboxChecked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00008 2.33334C5.31818 2.33334 2.33341 5.31811 2.33341 9.00001C2.33341 12.6819 5.31818 15.6667 9.00008 15.6667C12.682 15.6667 15.6667 12.6819 15.6667 9.00001C15.6667 5.31811 12.682 2.33334 9.00008 2.33334ZM0.666748 9.00001C0.666748 4.39763 4.39771 0.666672 9.00008 0.666672C13.6025 0.666672 17.3334 4.39763 17.3334 9.00001C17.3334 13.6024 13.6025 17.3333 9.00008 17.3333C4.39771 17.3333 0.666748 13.6024 0.666748 9.00001ZM12.0207 6.68261C12.38 6.97012 12.4383 7.49453 12.1508 7.85392L8.81747 12.0206C8.6694 12.2057 8.44951 12.319 8.21283 12.3321C7.97616 12.3452 7.7451 12.2569 7.57749 12.0893L5.91083 10.4226C5.58539 10.0972 5.58539 9.56952 5.91083 9.24408C6.23626 8.91865 6.7639 8.91865 7.08934 9.24408L8.09765 10.2524L10.8494 6.81276C11.1369 6.45337 11.6613 6.39511 12.0207 6.68261Z",
    fill: "#033272"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8065 9.00003C13.8065 11.6545 11.6546 13.8064 9.00008 13.8064C6.34558 13.8064 4.19369 11.6545 4.19369 9.00003C4.19369 6.34553 6.34558 4.19364 9.00008 4.19364C11.6546 4.19364 13.8065 6.34553 13.8065 9.00003Z",
    fill: "#033272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxChecked);
export default __webpack_public_path__ + "static/media/checkboxChecked.9c315c30c4e8f5e08fa65cda73d60139.svg";
export { ForwardRef as ReactComponent };